import React from "react";
import "../../style/UserDetail.css";
import { getUserDetailsRequest } from "../../../redux/actionDispatcher/admin/userDetailDispatcher";
import { connect, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import dummyProfileImage from "./../../assets/image/dummy-profile-image.png"
import { ApiURLs, imageBaseUrls } from "../../../constant/ApiUrls";
import moment from "moment";

const UserDetail = ({ userDetails, getUserDetailsRequest }) => {
    const { id } = useParams(); // Get the ID from the URL
    const userId = id.replace(":", "");
    console.log("User ID:", userId);
    const dispatch = useDispatch();
    React.useEffect(() => {
        getUserDetailsRequest(userId); // Fetch users only once when the component loads
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        userDetails.loading ?
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-4 mx-auto" style={{ backgroundColor: 'var(--primary-color)' }}></div>
            </div>
            :
            <div className="container">
                {/* User Header */}
                <div className="user-card"> 
                    <div className="user-header" style={{justifyContent:"center"}}>
                        <div className="user-info" style={{textAlign:"center"}}>
                            
                            <div className="user-details" style={{textAlign:"center"}}>
                                <img src={userDetails.usersDetails.image ? `${imageBaseUrls}${userDetails.usersDetails.image}` : dummyProfileImage} alt="Profile" className="user-avatar" style={{height:"100px", width:"100px", marginBottom:"10px"}} />
                                <h2 style={{marginBottom:"10px"}}>{userDetails.usersDetails.name}</h2>
                                <div>
                                <div style={{padding:"2px 10px", display:"inline-block", backgroundColor: userDetails.usersDetails.status === 1 ? "green" : "red",borderRadius:"10px"}}>
                                    
                                    <span
                                        style={{
                                            color:"white",
                                            fontWeight: "500",
                                            fontSize: "10px",
                                        }}
                                    >
                                        {userDetails.usersDetails.status === 1 ? "Active" : "Blocked"}
                                    </span>
                                </div>
                                </div>
                               
                                {/* <p>{userDetails.usersDetails.email} {userDetails.usersDetails.email_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</p>
                                <p>{userDetails.usersDetails.flag?"+":""}{userDetails.usersDetails.flag} {userDetails.usersDetails.number} {userDetails.usersDetails.otp_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</p> */}
                            </div>
    
                        </div>

                    </div>
                </div>

                {/* Personal Information */}
                {/* <div className="section">
        <div className="user-header">
          <h3>Personal Information</h3>
         
        </div>
        <div className="info-grid">
          <div className="info-item"><span>First Name:</span> {userDetails.personalInfo.firstName}</div>
          <div className="info-item"><span>Last Name:</span> {userDetails.personalInfo.lastName}</div>
          <div className="info-item"><span>Email:</span> {userDetails.personalInfo.email}</div>
          <div className="info-item"><span>Phone:</span> {userDetails.personalInfo.phone}</div>
          <div className="info-item"><span>Bio:</span> {userDetails.personalInfo.bio}</div>
        </div>
      </div> */}

                {/* Address */}
                <div className="section">
                    <div className="user-header">
                        <h3>Address</h3>

                    </div>
                    <div className="info-grid">
                        <div className="info-item"><span>Location:</span> {userDetails.usersDetails?.location_name==null?'Not Filled':userDetails.usersDetails?.location_name} </div>
                        {/* <div className="info-item"><span>City/State:</span> {userDetails.address.cityState}</div> */}
                        {/* <div className="info-item"><span>Postal Code:</span> {userDetails.address.postalCode}</div> */}
                        <div className="info-item"><span>Country:</span> Isle of Man</div>
                    </div>
                </div>

                <div className="section">
                    <div className="user-header">
                        <h3>Other Details</h3>

                    </div>

                    <div className="info-grid">
                        <div className="info-item"><span>Verified Email:</span>&nbsp;{userDetails.usersDetails.email} {userDetails.usersDetails.email_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</div>
                        {/* <div className="info-item"><span>City/State:</span> {userDetails.address.cityState}</div> */}
                        {/* <div className="info-item"><span>Postal Code:</span> {userDetails.address.postalCode}</div> */}
                        <div className="info-item"><span>Verified Number:</span>&nbsp;{userDetails.usersDetails.flag?"+":""}{userDetails.usersDetails.flag} {userDetails.usersDetails.number} {userDetails.usersDetails.otp_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</div>
                    </div>
                    <div className="info-grid">
                        <div className="info-item"><span>Join Date:</span> {moment(userDetails.usersDetails?.created_at).format("DD/MM/YYYY HH:mm:ss")}</div>
                        {/* <div className="info-item"><span>City/State:</span> {userDetails.address.cityState}</div> */}
                        {/* <div className="info-item"><span>Postal Code:</span> {userDetails.address.postalCode}</div> */}
                        <div className="info-item"><span>Hours Logged In:</span> {userDetails.usersDetails?.total_hours_logged} hrs</div>
                    </div>
                    <div className="info-grid">
                        <div className="info-item"><span>Ads Live:</span> {userDetails.usersDetails?.ads_count||0}</div>
                        {/* <div className="info-item"><span>City/State:</span> {userDetails.address.cityState}</div> */}
                        {/* <div className="info-item"><span>Postal Code:</span> {userDetails.address.postalCode}</div> */}
                        <div className="info-item"><span>Save Ads:</span> {userDetails.usersDetails?.saved_ad_count||0}</div>
                    </div>
                    <div className="info-grid">
                        <div className="info-item"><span>Ads Historically:</span> {userDetails.usersDetails?.recent_ads_count||0}</div>
                        {/* <div className="info-item"><span>City/State:</span> {userDetails.address.cityState}</div> */}
                        {/* <div className="info-item"><span>Postal Code:</span> {userDetails.address.postalCode}</div> */}
                        
                    </div>
                </div>
            </div>
    );
};



//Getting the state from the store
const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
    };
};

//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
    return {
        getUserDetailsRequest: (data, navigate) => dispatch(getUserDetailsRequest(data, navigate)),
    };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
